import styled from 'styled-components'
import theme from '../../styles/theme'

const Container = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  width: 100%;
  padding: 0 1.3rem;
  z-index: 4;
  top: 0;
  &:after{
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    right: 0;
    height: 80px;
    background: linear-gradient(rgba(0,0,0,0.5), transparent);
    z-index: -1;
  }
  a {
    color: #757575;
    transition: color 0.2s ease;
    text-decoration: none;
    &:hover {
      color: inherit;
    }
  }
  .slotSponsorLogo{
    display: flex;
    align-items: center;
  }
  .slotSponsor{
    font-size: 9px;
    text-transform: uppercase;
    color: white;
    span{
      display: block;
      padding-bottom: 2px;
    }
    svg, img{
      min-width: 40px;
    }
  }

  .slotLT{
    @media (max-width: 880px){
      display: none;
    }
  }
`;

const StLogo = styled.h1`
  font-family: ${theme.fontbody};
  font-size: 9px;
  text-align: center;
  color: white;
  text-transform: uppercase;

  svg, img{
    min-width: 100px;
    max-width: 100%;
    max-height: 30px;
  }
`

export { Container, StLogo }